<template>
  <v-tooltip text="Copy" location="top">
    <template #activator="{ props }">
      <v-icon v-bind="props" @click="copy" size="small">mdi-content-copy</v-icon>
    </template>
  </v-tooltip>
</template>

<script setup>
import { useDebugStore } from "../../stores/debug";

const debugStore = useDebugStore();

const props = defineProps({
  text: String,
});

function copy() {
  debugStore.copyToClipboard(props.text);
}
</script>

<style scoped>
.v-icon {
  font-size: 14px;
}
</style>
